import { Controller } from "@hotwired/stimulus"

// The "I wanna collab" modal on an offer page: pick a day and a moment (or a
// week), press the button. The picks become one sentence in the hidden
// `wanted` field — and the chip's date in `wanted_on`, which is what Planning
// groups by — and the form posts the request to the merchant; the page comes
// back with the request reading under the card. The chips stay client-side
// until offer_slots (spec-v2 lot 3) make them real. "Whenever" is a day chip
// like the others, with neither date nor label: picking it says nothing, which
// is exactly the wish.
export default class extends Controller {
  static targets = ["day", "moment", "form", "wanted", "wantedOn", "range", "rangeChip"]

  pickDay(event) {
    this.#pick(this.dayTargets, event.currentTarget)
    this.#closeRange()
  }
  pickMoment(event) { this.#pick(this.momentTargets, event.currentTarget) }

  // "Between dates": two date fields beside the chip, always on screen
  // (9 Sep 2026 — hiding them made the row jump). Turning it on drops the day
  // pick — a week and a range are two answers to the same question — turning
  // it off empties the fields, so nothing stale is posted. Typing a date turns
  // it on by itself.
  pickRange() { this.#setRange(this.rangeChipTarget.dataset.active !== "true") }
  typeRange() { this.#setRange(true) }

  #setRange(on) {
    this.rangeChipTarget.dataset.active = String(on)
    if (on) this.dayTargets.forEach(c => { c.dataset.active = "false" })
    else this.rangeTarget.querySelectorAll("input[type=date]").forEach(i => { i.value = "" })
  }

  #closeRange() {
    if (!this.hasRangeTarget || this.rangeChipTarget.dataset.active !== "true") return
    this.#setRange(false)
  }

  submit() {
    // A range posts itself (the two fields are named); the chips only carry
    // the moment then, which the server appends to the range's sentence.
    const day = this.dayTargets.find(c => c.dataset.active === "true")
    const moment = this.momentTargets.find(c => c.dataset.active === "true")
    if (this.hasWantedTarget) this.wantedTarget.value = [day?.dataset.label, moment?.dataset.label].filter(Boolean).join(", ")
    if (this.hasWantedOnTarget) this.wantedOnTarget.value = day?.dataset.date || ""
    this.formTarget.requestSubmit()
  }

  // One active chip per row; clicking the active chip clears the pick.
  #pick(chips, chosen) {
    chips.forEach(c => { c.dataset.active = String(c === chosen && c.dataset.active !== "true") })
  }
}
